/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Privacy_PolicyInputs */

const en_svchip_privacy_policy = /** @type {(inputs: Svchip_Privacy_PolicyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacy policy`)
};

const ar_svchip_privacy_policy = /** @type {(inputs: Svchip_Privacy_PolicyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سياسة الخصوصية`)
};

const bn_svchip_privacy_policy = /** @type {(inputs: Svchip_Privacy_PolicyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`প্রাইভেসি পলিসি`)
};

const de_svchip_privacy_policy = /** @type {(inputs: Svchip_Privacy_PolicyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datenschutzrichtlinie`)
};

const es_svchip_privacy_policy = /** @type {(inputs: Svchip_Privacy_PolicyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Política de privacidad`)
};

const fr_svchip_privacy_policy = /** @type {(inputs: Svchip_Privacy_PolicyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Politique de confidentialité`)
};

const pt_svchip_privacy_policy = /** @type {(inputs: Svchip_Privacy_PolicyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Política de privacidade`)
};

const zh_svchip_privacy_policy = /** @type {(inputs: Svchip_Privacy_PolicyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`隐私政策`)
};

const tr_svchip_privacy_policy = /** @type {(inputs: Svchip_Privacy_PolicyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gizlilik politikası`)
};

const ru_svchip_privacy_policy = /** @type {(inputs: Svchip_Privacy_PolicyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Политика конфиденциальности`)
};

const pl_svchip_privacy_policy = /** @type {(inputs: Svchip_Privacy_PolicyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polityka prywatności`)
};

/**
* | output |
* | --- |
* | "Privacy policy" |
*
* @param {Svchip_Privacy_PolicyInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_privacy_policy = /** @type {((inputs?: Svchip_Privacy_PolicyInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Privacy_PolicyInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_privacy_policy(inputs)
	if (locale === "bn") return bn_svchip_privacy_policy(inputs)
	if (locale === "de") return de_svchip_privacy_policy(inputs)
	if (locale === "es") return es_svchip_privacy_policy(inputs)
	if (locale === "fr") return fr_svchip_privacy_policy(inputs)
	if (locale === "pt") return pt_svchip_privacy_policy(inputs)
	if (locale === "zh") return zh_svchip_privacy_policy(inputs)
	if (locale === "tr") return tr_svchip_privacy_policy(inputs)
	if (locale === "ru") return ru_svchip_privacy_policy(inputs)
	if (locale === "pl") return pl_svchip_privacy_policy(inputs)
	return en_svchip_privacy_policy(inputs)
});